export default "__VITE_ASSET__DW1Ddf4v__"